class Question {
  public readonly question: string;
  public readonly answerOptions: string[];
  constructor({ question, answerOptions }: { question: string; answerOptions: string[] }) {
    this.question = question;
    this.answerOptions = answerOptions;
  }

  public static fromJSON = (value: any) => {
    const { question, answer_options } = Object.assign({}, value);
    const answerOptions = answer_options;

    if (typeof question !== 'string') throw new TypeError('.question must be a string');
    return new Question({
      question,
      answerOptions,
    });
  };
}

export default Question;
